module.exports = __webpack_public_path__ + "static/media/fb.8b09d7bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/fb.svg
// module id = ./src/common/images/fb.svg
// module chunks = 1